<script>
import Layout from '@layouts/flight.vue'


import ScrollRow from '@components/scrollRow.vue'

import axios from 'axios'

import moment from 'moment'
import _ from 'underscore'

import FltCard from '@components/fltCard.vue'

import { statusSummaryCellRenderer } from './../../components/grid/flightStatusCellRenderer.js'
import { getFlightConfig } from '@utils/helpers.js'

const reduceByKey = (data, key) =>
  _.reduce(
    data,
    function(memo, obj) {
      return memo + obj[key]
    },
    0
  )

const filterObj = {
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: false,
    resetButton: true,
  },
  resizable: true,
  sortable: true,
}

const brdFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'BrdMale'),
    reduceByKey(data.PaxTotals, 'BrdFemale'),
    reduceByKey(data.PaxTotals, 'BrdChild'),
    reduceByKey(data.PaxTotals, 'BrdInfant'),
  ].join('/')
}

const bkdFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'ResFirst'),
    reduceByKey(data.PaxTotals, 'ResBusiness'),
    reduceByKey(data.PaxTotals, 'ResEconomy'),
  ].join('/')
}

const ckdFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'CkdFirst'),
    reduceByKey(data.PaxTotals, 'CkdBusiness'),
    reduceByKey(data.PaxTotals, 'CkdEconomy'),
  ].join('/')
}

const bkdMFCIFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'ResMale'),
    reduceByKey(data.PaxTotals, 'ResFemale'),
    reduceByKey(data.PaxTotals, 'ResChild'),
    reduceByKey(data.PaxTotals, 'ResInfant'),
  ].join('/')
}

const ckdMFCIFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.PaxTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.PaxTotals, 'CkdMale'),
    reduceByKey(data.PaxTotals, 'CkdFemale'),
    reduceByKey(data.PaxTotals, 'CkdChild'),
    reduceByKey(data.PaxTotals, 'CkdInfant'),
  ].join('/')
}

const bagsFormatter = function(params) {
  // formatters called from col def differs to if you call it
  // from the export CSV func. Check where data is located.
  const data = params.data || params.node.data
  if (!data.BagTotals.length) {
    return ' - '
  }
  return [
    reduceByKey(data.BagTotals, 'TotalFirstPieces'),
    reduceByKey(data.BagTotals, 'TotalBusinessPieces'),
    reduceByKey(data.BagTotals, 'TotalEconomyPieces'),
  ].join('/')
}

const lsKeyBaggage = 'insightShowBaggage'

const exportParams = {
  fileName: 'flightsExport.csv',
  suppressQuotes: false,
  columnSeparator: ',',
  processCellCallback: function(cellParams) {
    if (cellParams && cellParams.column.colId === 'StdDate') {
      return moment(cellParams.value).format('DDMMMYY')
    } else if (cellParams && cellParams.column.colId === 'Std') {
      return moment(cellParams.value).format('HH:mm') // apply your object formatter
    } else if (cellParams && cellParams.column.colId === 'BoardTime') {
      return cellParams.value ? moment(cellParams.value).format('HH:mm') : '-' // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '0') {
      // Config
      return getFlightConfig(cellParams.node.data) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '1') {
      // Bkd
      return bkdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '2') {
      // Ckd
      return ckdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '3') {
      // bkdMFCI
      return bkdMFCIFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '4') {
      // ckdMFCI
      return ckdMFCIFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '5') {
      return brdFormatter(cellParams) // apply your object formatter
    } else if (cellParams && cellParams.column.colId === '6') {
      return bagsFormatter(cellParams) // apply your object formatter
    } else return cellParams.value // no formatting
  },
}

const columnDefs = [
  { field: 'FlightNumber', pinned: true, width: 60, ...filterObj },
  {
    field: 'StdDate',
    headerName: 'Date',
    width: 75,
    pinned: true,
    valueFormatter: function(params) {
      return moment(params.value)
        .format('DDMMM')
        .toUpperCase()
    },
    ...filterObj,
  },
  {
    field: 'Std',
    headerName: 'STD',
    width: 75,
    pinned: true,
    valueFormatter: function(params) {
      return moment(params.value).format('HH:mm')
    },
    ...filterObj,
  },
  { field: 'Equipment', headerName: 'Equipment', ...filterObj },
  {
    headerName: 'Config',
    valueFormatter: function(params) {
      return getFlightConfig(params.data)
    },
    ...filterObj,
  },
  { field: 'Registration' },
  { field: 'Destinations', width: 75, ...filterObj },
  {
    field: 'FlightStatus',
    cellRenderer: statusSummaryCellRenderer,
  },
  {
    headerName: 'Bkd [FCY]',
    valueFormatter: bkdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Ckd [FCY]',
    valueFormatter: ckdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Bkd [MFCI]',
    valueFormatter: bkdMFCIFormatter,
    ...filterObj,
  },
  {
    headerName: 'Ckd [MFCI]',
    valueFormatter: ckdMFCIFormatter,
    ...filterObj,
  },
  {
    headerName: 'Brd [FCY]',
    valueFormatter: brdFormatter,
    ...filterObj,
  },
  {
    headerName: 'Bags [FCY]',
    valueFormatter: bagsFormatter,
    ...filterObj,
  },
  { field: 'BoardGate', headerName: 'Gate', ...filterObj },
  {
    field: 'BoardTime',
    headerName: 'Board Time',

    valueFormatter: function(params) {
      return params.value ? moment(params.value).format('HH:mm') : ''
    },
    ...filterObj,
  },

  { field: 'OffblocksTime', headerName: 'ACT', width: 75, pinned: 'right' },
  { field: 'TakeoffTime', headerName: 'ADT', width: 75, pinned: 'right' },
  { field: 'Remarks', pinned: 'right' },
]
// Axios
const CancelToken = axios.CancelToken
let cancel

export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.user.name}.`,
        },
      ],
    }
  },
  components: { Layout, FltCard, ScrollRow },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hidden: {
        left: 0,
        right: 0,
      },
      baggageShown: false,
      columnDefs: columnDefs,
      paxFilter: null,
      gridData: [],
      isLoading: false,
      lastUpdated: [{ type: 'flights', timestamp: null }],
      sideBarVisible: true,
      flightStatusStats: [
        { caption: 'Scheduled', state: false },
        { caption: 'Open', state: false },
        { caption: 'Closed', state: false },
        { caption: 'Finalized', state: false },
        { caption: 'Cancelled', state: false },
      ],
      params: { rollFlights: true, timeWindowFrom: -1440, timeWindowTo: 4320 },
      paramsSchema: [
        {
          fieldType: 'Checkbox',
          multi: false,
          value: null,
          name: 'rollFlights',
          label: 'Rolling Flights View',
        },
        {
          fieldType: 'TextInput',
          placeholder: 'e.g. -440',
          multi: false,
          value: null,
          name: 'timeWindowFrom',
          label: 'Time Window (From)',
        },
        {
          fieldType: 'TextInput',
          placeholder: 'e.g. 4320',
          multi: false,
          value: null,
          name: 'timeWindowTo',
          label: 'Time Window (To)',
        },
        // {
        //   fieldType: 'MultiSelect',
        //   placeholder: 'Select Carriers',
        //   multi: true,
        //   value: null,
        //   name: 'carrier',
        //   label: 'Carriers',
        // },
      ],
    }
  },
  computed: {
    scheduledFlts() {
      return this.gridData.filter((flt) => flt.FlightStatus === 'SCHEDULED')
    },
    openFlts() {
      return this.gridData.filter((flt) => flt.FlightStatus === 'OPEN')
    },
    closedFlts() {
      return this.gridData.filter((flt) => flt.FlightStatus === 'CLOSED')
    },
    cancelledFlts() {
      return this.gridData.filter((flt) => flt.FlightStatus === 'CANCELLED')
    },
    finalisedFlts() {
      return this.gridData.filter(
        (flt) =>
          flt.FlightStatus === 'FINALIZED' || flt.FlightStatus === 'DEPARTED'
      )
    },
    selectedFlightId() {
      return this.$store.getters['flights/getSelectedFlightId']
    },
    filterStatus() {
      const filters = this.flightStatusStats
        .filter((state) => state.state)
        .map((state) => {
          return state.caption.toUpperCase()
        })

      return filters
    },
    selectedFlightDate() {
      return this.$store.getters['flights/getSelectedFlightDate']
    },
    startDate() {
      return moment(this.selectedFlightDate.startDate).format('DDMMMYY')
    },
  },
  watch: {
    params: {
      deep: true,
      handler(params) {
        this.getData()
      },
    },
    flightStatusStats: {
      deep: true,
      handler() {
        this.getData()
      },
    },
    selectedFlightDate: {
      handler(date) {
        this.getData()
      },
    },
  },

  timers: {
    getData: { time: 30000, autostart: true, repeat: true },
  },
  mounted() {
    this.getData()
    const lsBaggage = JSON.parse(localStorage.getItem(lsKeyBaggage)) || false
    this.baggageShown = lsBaggage
  },
  methods: {
    showBaggage() {
      this.baggageShown = !this.baggageShown
      localStorage.setItem(lsKeyBaggage, this.baggageShown)
    },
    reduceByKey: reduceByKey,
    fltsByStatus(data, key, value) {
      return data.filter((d) => data[key] === value)
    },
    moment: moment,
    printGrid() {
      this.$refs.grid.onBtPrint()
    },
    csvExport() {
      this.$refs.grid.onBtnExport(exportParams)
    },
    onSelectionChanged(data) {
      this.$store.dispatch('flights/SET_SELECTED_FLIGHT_ID', data[0].FlightId)
    },
    openPaxSummary() {
      this.$router.push(`/paxsummary/${this.selectedFlightId}`)
    },
    getData() {
      this.isLoading = true

      if (cancel !== undefined) {
        cancel()
      }
      var uri
      if (this.params.rollFlights === true) {
        uri = `${this.$config.apiBaseUrl}flights/window/${this.params.timeWindowFrom},${this.params.timeWindowTo}`
      }
      if (this.params.rollFlights === false) {
        uri = `${this.$config.apiBaseUrl}flights/start/${this.startDate}/end/${this.startDate}`
      }
      axios
        .get(uri, {
          cancelToken: new CancelToken((c) => {
            cancel = c
          }),
        })
        .then((response) => {
          const data = response.data.Results[0]
          // filter flight status
          // Get an array of selected flight statuses
          const selectedFlightStatus = this.flightStatusStats.filter(
            (_status) => _status.state
          )
          // Map the caption (rather than the state)
          const flightStatusFilters = selectedFlightStatus.map((_status) =>
            _status.caption.toUpperCase()
          )

          if (flightStatusFilters.indexOf('FINALIZED') > -1) {
            flightStatusFilters.push('DEPARTED')
          }
          // Process data
          if (flightStatusFilters.length) {
            this.gridData = data.filter((_flight) => {
              const x = flightStatusFilters.indexOf(_flight.FlightStatus)
              if (x > -1) {
                return _flight
              }
            })
          } else {
            this.gridData = data
          }
          // this.gridData = data
          this.lastUpdated[0].timestamp = response.data.Timestamp
          this.$store.dispatch('flights/SET_FLIGHTS', data)
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          cancel()
          this.isLoading = false
          console.log(this.$refs)
          Object.keys(this.$refs).forEach((scroll) => {
            this.$refs[scroll].initSlider()
          })
          // this.$refs.scrollView.forEach((scroll) => {
          //   scroll.initSlider()
          // })
        })
    },
  },
}
</script>

<template>
  <Layout
    id="fltBoard"
    :last-updated="lastUpdated"
    :params="params"
    :params-schema="paramsSchema"
  >
    <div class="content-container">
      <div class="chat-module" data-filter-list="chat-module-body">
        <div class="toolbar row p-2">
          <div class="col-2"></div>
          <div class="col-7">
            <button
              class="btn btn-sm btn-primary btn-refresh mr-2"
              :disabled="isLoading"
              @click="getData"
              >{{ isLoading ? 'Refreshing...' : 'Refresh' }}</button
            >

            <button
              class="btn btn-sm btn-primary btn-refresh mr-2"
              :disabled="isLoading"
              @click="showBaggage"
              >{{ baggageShown ? 'Hide Baggage' : 'Show Baggage' }}</button
            >

            <b-button-group size="sm">
              <b-button
                v-for="(btn, idx) in flightStatusStats"
                :key="idx"
                :pressed.sync="btn.state"
                variant="primary"
                >{{ btn.caption }}</b-button
              >
            </b-button-group>
          </div>
          <div class="col-3 text-right"></div>
        </div>

        <ScrollRow ref="scrollView1" title="Scheduled" aclass="scheduled">
          <div
            v-for="(flt, index) in scheduledFlts"
            :key="index"
            class="col-md-2"
          >
            <FltCard :baggage-shown="baggageShown" :flt="flt" />
          </div>
        </ScrollRow>

        <ScrollRow ref="scrollView2" title="Open" aclass="open">
          <div v-for="(flt, index) in openFlts" :key="index" class="col-md-2">
            <FltCard :baggage-shown="baggageShown" :flt="flt" />
          </div>
        </ScrollRow>

        <ScrollRow ref="scrollView3" title="Closed" aclass="closed">
          <div v-for="(flt, index) in closedFlts" :key="index" class="col-md-2">
            <FltCard :baggage-shown="baggageShown" :flt="flt" />
          </div>
        </ScrollRow>

        <ScrollRow ref="scrollView4" title="Cancelled" aclass="cancelled">
          <div
            v-for="(flt, index) in cancelledFlts"
            :key="index"
            class="col-md-2"
          >
            <FltCard :baggage-shown="baggageShown" :flt="flt" />
          </div>
        </ScrollRow>

        <ScrollRow ref="scrollView5" title="Finalized" aclass="finalized">
          <div
            v-for="(flt, index) in finalisedFlts"
            :key="index"
            class="col-md-2"
          >
            <FltCard :baggage-shown="baggageShown" :flt="flt" />
          </div>
        </ScrollRow>

        <!-- <div class="card-box row">
          <div class="outer closed col-md-1">
            <div class="inner rotate text-white">Closed</div>
          </div>
          <div v-for="(flt, index) in closedFlts" :key="index" class="col-md-2">
            <FltCard :baggageShown="baggageShown" :flt="flt" />
          </div>
        </div> -->

        <!-- <div class="card-box row">
          <div class="outer cancelled col-md-1">
            <div class="inner rotate text-white">Cancelled</div>
          </div>
          <div
            v-for="(flt, index) in cancelledFlts"
            :key="index"
            class="col-md-2"
          >
            <FltCard :baggageShown="baggageShown" :flt="flt" />
          </div>
        </div> -->
        <!-- 
        <div class="card-box row">
          <div class="outer finalized col-md-1">
            <div class="inner rotate text-white">Finalized</div>
          </div>
          <div
            v-for="(flt, index) in finalisedFlts"
            :key="index"
            class="col-md-2"
          >
            <FltCard :baggageShown="baggageShown" :flt="flt" />
          </div>
        </div> -->
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.chat-module {
  justify-content: start;
}
.card-box.row {
  border-bottom: 1px solid #e7eaec;
  margin: 0 0rem;
  border-top: 1px solid #e7eaec;
  margin-bottom: -1px;
  align-items: flex-end;
  align-content: center;
}
.outer {
  height: 150px;
  max-width: 56px !important;
}
.cardarea-half {
}
.rotate {
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
}
.inner {
  font-size: 13px;
  font-color: #878787;
  position: absolute;
  top: 50%;
  left: 50%;
}
.layout-nav-side .content-container > .chat-module,
.layout-sidebar .content-container > .chat-module {
  overflow: hidden;
  padding: 0;
  align-content: flex-start;
}

.row {
  overflow: hidden;
  width: 100%;
  flex-wrap: nowrap;
}
.row.active {
  background: rgba(255, 255, 255, 0.3);
  cursor: grabbing;
  cursor: -webkit-grabbing;
  transform: scale(1.015);
}
.hidden {
  height: 100%;
  position: absolute;
  background: #f8f9fa88;
  z-index: 999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 105px;
  text-align: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-weight: 600;
  font-size: 17px;
}
.hidden.right {
  right: 0;
}
.hidden span {
  background: #242835;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  color: white;
}
.hidden.left {
  background: linear-gradient(90deg, #f8f9fa 35%, transparent);
  width: 60px;
}
.hidden.right {
  background: linear-gradient(-90deg, #f8f9fa 35%, transparent);
}
</style>
